
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "bf95674c9637855ca4553cd095ce9d3f8bd94b33",
  "nuxt": {
    "buildId": "fcdb4ee4-037a-4797-a73a-6c82d90016a6"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
